webpackJsonp([188519706403221],{

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "vocatus"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "us"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "am"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "um"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "o"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "i"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "ae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "arum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "orum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "os"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "as"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "vocat\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "is"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Het rijtje van het ppp gaat dus volgens het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "bijvoeglijk-naamwoord" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "longus"
	          )
	        ),
	        "."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _ppp = __webpack_require__(667);
	
	var _ppp2 = _interopRequireDefault(_ppp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "31",
	  table: _ppp2.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, { defaultChapter: "31", data: data, title: "PPP" });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-ppp-js-04845d15260712dc0450.js